var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("w-tabs", {
        staticClass: "mb",
        style: { marginLeft: "2px" },
        attrs: { tabs: _vm.tabs },
        model: {
          value: _vm.activeTab,
          callback: function ($$v) {
            _vm.activeTab = $$v
          },
          expression: "activeTab",
        },
      }),
      _vm.tab == "overview" && _vm.activeInvoice.length > 0
        ? _c(
            "div",
            { staticClass: "active mb" },
            _vm._l(_vm.activeInvoice, function (invoice) {
              return _c("app-invoice-list-entry", {
                key: invoice.ID,
                attrs: { invoice: invoice, open: true, "can-pay": _vm.canPay },
                nativeOn: {
                  click: function ($event) {
                    return _vm.invoiceClicked(invoice)
                  },
                },
              })
            }),
            1
          )
        : _vm._e(),
      _c(
        "div",
        [
          (_vm.tab == "overview" &&
            _vm.expiredInvoices.length > 0 &&
            _vm.showOnOverview("unpaid")) ||
          (_vm.tab == "unpaid" && _vm.expiredInvoices.length > 0)
            ? _c(
                "w-card",
                { staticClass: "mb" },
                [
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        { staticClass: "title-container" },
                        [
                          _c("w-list-item-text", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$ct("expired-invoices"))),
                          ]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.getCollapseTooltip(
                                        _vm.showExpired
                                      ),
                                      expression:
                                        "getCollapseTooltip(showExpired)",
                                    },
                                  ],
                                  staticClass: "collapse",
                                  on: {
                                    click: function ($event) {
                                      _vm.showExpired = !_vm.showExpired
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    attrs: {
                                      icon: _vm.getChevron(_vm.showExpired),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-transition-slide-height", [
                        _vm.showExpired
                          ? _c(
                              "div",
                              [
                                _c("app-invoice-list-header", {
                                  attrs: {
                                    "show-total": _vm.activeTab != 0,
                                    open: true,
                                  },
                                }),
                                _c(
                                  "div",
                                  _vm._l(
                                    _vm.expiredInvoices,
                                    function (invoice) {
                                      return _c("app-invoice-list-entry", {
                                        key: invoice.ID,
                                        attrs: {
                                          invoice: invoice,
                                          open: true,
                                          "can-pay": _vm.canPay,
                                          "show-total": _vm.activeTab != 0,
                                          info: _vm.getInfo("unpaid"),
                                        },
                                        nativeOn: {
                                          click: function ($event) {
                                            return _vm.invoiceClicked(invoice)
                                          },
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _c(
        "div",
        [
          (_vm.tab == "overview" && _vm.showOnOverview("unpaid")) ||
          _vm.tab == "unpaid"
            ? _c(
                "w-card",
                { staticClass: "mb" },
                [
                  _c(
                    "w-list",
                    [
                      _c(
                        "w-list-item",
                        { staticClass: "title-container" },
                        [
                          _c("w-list-item-text", { staticClass: "title" }, [
                            _vm._v(_vm._s(_vm.$ct("open-invoices"))),
                          ]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.getCollapseTooltip(
                                        _vm.showOpen
                                      ),
                                      expression:
                                        "getCollapseTooltip(showOpen)",
                                    },
                                  ],
                                  staticClass: "collapse",
                                  on: {
                                    click: function ($event) {
                                      _vm.showOpen = !_vm.showOpen
                                    },
                                  },
                                },
                                [
                                  _c("w-fa", {
                                    attrs: {
                                      icon: _vm.getChevron(_vm.showOpen),
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c("w-transition-slide-height", [
                        _vm.showOpen
                          ? _c(
                              "div",
                              [
                                _c("app-invoice-list-header", {
                                  attrs: {
                                    "show-total": _vm.activeTab != 0,
                                    open: true,
                                  },
                                }),
                                _vm.openInvoices.length > 0
                                  ? _c(
                                      "div",
                                      _vm._l(
                                        _vm.openInvoices,
                                        function (invoice) {
                                          return _c("app-invoice-list-entry", {
                                            key: invoice.ID,
                                            attrs: {
                                              invoice: invoice,
                                              "show-total": _vm.activeTab != 0,
                                              open: true,
                                              "can-pay": _vm.canPay,
                                              info: _vm.getInfo("unpaid"),
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.invoiceClicked(
                                                  invoice
                                                )
                                              },
                                            },
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  : _c(
                                      "div",
                                      [
                                        _c(
                                          "w-list-item",
                                          [
                                            _c(
                                              "w-list-item-text",
                                              [
                                                _c(
                                                  "w-row",
                                                  [
                                                    _c(
                                                      "w-col",
                                                      { attrs: { xs: "12" } },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            _vm.$ct(
                                                              "empty-list"
                                                            )
                                                          )
                                                        ),
                                                      ]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.showEstimates && (_vm.activeTab == 0 || _vm.activeTab == 3)
        ? _c(
            "w-card",
            { staticClass: "mb", attrs: { grow: "" } },
            [
              _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    { staticClass: "title-container" },
                    [
                      _c("w-list-item-text", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$ct("open-estimates"))),
                      ]),
                      _c(
                        "w-button",
                        {
                          directives: [
                            {
                              name: "tooltip",
                              rawName: "v-tooltip",
                              value: _vm.getCollapseTooltip(
                                _vm.showEstimatesBlock
                              ),
                              expression:
                                "getCollapseTooltip(showEstimatesBlock)",
                            },
                          ],
                          staticClass: "collapse",
                          on: {
                            click: function ($event) {
                              _vm.showEstimatesBlock = !_vm.showEstimatesBlock
                            },
                          },
                        },
                        [
                          _c("w-fa", {
                            attrs: {
                              icon: _vm.getChevron(_vm.showEstimatesBlock),
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-transition-slide-height", [
                    _vm.showEstimatesBlock
                      ? _c(
                          "div",
                          [
                            _c("app-estimate-list-header"),
                            _c("div", [
                              _vm.openEstimates.length > 0
                                ? _c(
                                    "div",
                                    _vm._l(
                                      _vm.openEstimates,
                                      function (estimate) {
                                        return _c("app-estimate-list-entry", {
                                          key: estimate.ID,
                                          attrs: {
                                            estimate: estimate,
                                            info: _vm.getInfo(estimate.TypeID),
                                          },
                                          on: {
                                            sign: function ($event) {
                                              return _vm.estimateSignClicked(
                                                estimate
                                              )
                                            },
                                          },
                                        })
                                      }
                                    ),
                                    1
                                  )
                                : _c(
                                    "div",
                                    [
                                      _c(
                                        "w-list-item",
                                        [
                                          _c(
                                            "w-list-item-text",
                                            [
                                              _c(
                                                "w-row",
                                                [
                                                  _c(
                                                    "w-col",
                                                    { attrs: { xs: "12" } },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          _vm.$ct("empty-list")
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                            ]),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      (_vm.tab == "overview" && _vm.showOnOverview("paid")) || _vm.tab == "paid"
        ? _c(
            "w-card",
            { staticClass: "mb" },
            [
              _c(
                "w-list",
                [
                  _c(
                    "w-list-item",
                    { staticClass: "title-container" },
                    [
                      _c("w-list-item-text", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.$ct("paid-invoices"))),
                      ]),
                      _c(
                        "w-list-item-action",
                        [
                          _c(
                            "w-button",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value: _vm.getCollapseTooltip(_vm.showPayed),
                                  expression: "getCollapseTooltip(showPayed)",
                                },
                              ],
                              staticClass: "collapse",
                              on: {
                                click: function ($event) {
                                  _vm.showPayed = !_vm.showPayed
                                },
                              },
                            },
                            [
                              _c("w-fa", {
                                attrs: { icon: _vm.getChevron(_vm.showPayed) },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("w-transition-slide-height", [
                    _vm.showPayed
                      ? _c(
                          "div",
                          [
                            _c("app-invoice-list-header"),
                            _vm.invoices.length > 0
                              ? _c(
                                  "div",
                                  _vm._l(_vm.invoices, function (invoice) {
                                    return _c("app-invoice-list-entry", {
                                      key: invoice.ID,
                                      attrs: {
                                        invoice: invoice,
                                        info: _vm.getInfo("paid"),
                                      },
                                      on: {
                                        click: function ($event) {
                                          return _vm.invoiceClicked(invoice)
                                        },
                                      },
                                    })
                                  }),
                                  1
                                )
                              : _c(
                                  "div",
                                  [
                                    _c(
                                      "w-list-item",
                                      [
                                        _c(
                                          "w-list-item-text",
                                          [
                                            _c(
                                              "w-row",
                                              [
                                                _c(
                                                  "w-col",
                                                  { attrs: { xs: "12" } },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.$ct("empty-list")
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._l(_vm.additionalSalesPerType, function (sales, index) {
        return _c(
          "div",
          { key: index },
          [
            !sales.signed &&
            !sales.unsigned &&
            ("tab" + index == _vm.tab || _vm.showOnOverview("tab" + index))
              ? _c("additional-invoice-list", {
                  attrs: {
                    title: _vm.additionalTabName(index),
                    "can-be-signed": _vm.canBeSignedByClient(index),
                    invoices: sales,
                    info: _vm.getInfo(index),
                  },
                  on: {
                    "estimate-sign-clicked": function ($event) {
                      return _vm.estimateSignClicked($event)
                    },
                  },
                })
              : _vm._e(),
            sales.unsigned &&
            ("tab" + index == _vm.tab || _vm.showOnOverview("tab" + index))
              ? _c("additional-invoice-list", {
                  attrs: {
                    title: _vm.getTitle(index)
                      ? _vm.getTitle(index)
                      : _vm.$ct("need-sign").toString(),
                    "can-be-signed": _vm.canBeSignedByClient(index),
                    invoices: sales.unsigned,
                    info: _vm.getInfo(index),
                  },
                  on: {
                    "estimate-sign-clicked": function ($event) {
                      return _vm.estimateSignClicked($event)
                    },
                  },
                })
              : _vm._e(),
            sales.signed &&
            ("tab" + index == _vm.tab || _vm.showOnOverview("tab" + index))
              ? _c("additional-invoice-list", {
                  attrs: {
                    title: _vm.additionalTabName(index),
                    "can-be-signed": _vm.canBeSignedByClient(index),
                    invoices: sales.signed,
                    info: _vm.getInfo(index),
                  },
                  on: {
                    "estimate-sign-clicked": function ($event) {
                      return _vm.estimateSignClicked($event)
                    },
                  },
                })
              : _vm._e(),
          ],
          1
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }